export const SET_PAGE = 'page:set'
